import { jsx as _jsx } from "react/jsx-runtime";
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
/**
 * Registers Ask's connector selector in the Composer plus menu.
 *
 * Hosts that enable cloud-file connectors must mount Ask's
 * `ConnectorFilePickerProvider` above `Composer` so picker state outlives the
 * closing plus menu.
 */
export function createConnectorSelectorPluginFactory() {
    return createPluginFactory({
        name: 'connector-selector',
        capabilities: [
            {
                kind: 'plusMenu',
                items: async () => {
                    const { ConnectorSelectorPlusMenuItem } = await import('#pplx/frontend/apps/ask/composer-sdk-plugins/connector-selector/internal/ConnectorSelectorPlusMenuItem.js');
                    return [
                        {
                            id: 'connectors',
                            render: (context) => _jsx(ConnectorSelectorPlusMenuItem, { ...context }),
                        },
                    ];
                },
            },
        ],
    });
}
//# sourceMappingURL=index.js.map